import React, { useEffect, useState } from 'react';
import { FaChevronDown, FaChevronRight, FaExternalLinkAlt } from "react-icons/fa";
import Form from 'react-bootstrap/Form';
import Pagination from  '../../../components/Pagination/Pagination';
import Spinner from 'react-bootstrap/Spinner';
import { API } from 'aws-amplify';
import Moment from 'react-moment';
import moment from 'moment';
import { Link } from 'react-router-dom';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import DatePickerPopperContainer from '../../../components/DatePickerPopperContainer';

import '../../../styles/compact-filters.css';
import '../../../styles/ops-list.css';
import '../../../components/PageHeader/PageHeader.css';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { useI18n } from '../../../i18n';
import './MonthlyReport.css';
import MonthlyReportXls from './MonthlyReportXls';

import * as localdb from '../../../localdb';

const FILTERS_KEY = "monthlyReportFilters";
const PAGE_SIZE_KEY = "monthlyReportPageSize";
const PAGE_SIZES = [10, 25, 50];

function formatWhen(value) {
	if (!value) return '';
	const m = moment(value);
	return m.isValid() ? m.format('D MMM YYYY, HH:mm') : String(value);
}

function isUrgentItem(item) {
	return String(item.urgent_fault || '').toLowerCase() === 'urgent';
}

const MonthlyReport = (props) => {
	const { t, tCatalog, language } = useI18n();
	const [tasks, setTasks] = useState([]);
	const [taskList, setTaskList] = useState([]);
	const [taskReport, setTaskReport] = useState([]);
	const [taskReportList, setTaskReportList] = useState([]);
	const [users, setUsers] = useState([]);	
    const [dateFrom, setDateFrom] = useState('');
	const [dateTo, setDateTo] = useState('');
	const [dateCompletedFrom, setDateCompletedFrom] = useState('');
	const [dateCompletedTo, setDateCompletedTo] = useState('');
	const [siteRef,setSiteRef] = useState('');
	const [taskRef,setTaskRef] = useState('');
	const [district, setDistrict] = useState('');
	const [category, setCategory] = useState('');
	const [subcategory, setSubcategory] = useState('');
	const [invoiceStatus, setInvoiceStatus] = useState('');
	const [taskStatus, setTaskStatus] = useState('');
	const [subcategoryList, setSubcategoryList] = useState([]);
	const [districtList, setDistrictList] = useState([]);
	const [appliedFilters, setAppliedFilters] = useState({
		dateFrom: '',
		dateTo: '',
		dateCompletedFrom: '',
		dateCompletedTo: '',
		siteRef: '',
		taskRef: '',
		district: '',
		category: '',
		subcategory: '',
		invoiceStatus: '',
		taskStatus: '',
	});

	const [isLoading, setIsLoading] = useState(true);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(() => {
		const n = parseInt(localStorage.getItem(PAGE_SIZE_KEY), 10);
		return PAGE_SIZES.includes(n) ? n : 10;
	});
	const [expandedId, setExpandedId] = useState(null);
	const [showMoreFilters, setShowMoreFilters] = useState(false);

	const [filtersLoaded, setFiltersLoaded] = useState(false);
	const [tasksLoaded, setTasksLoaded] = useState(false);
	const [exportDetailsById, setExportDetailsById] = useState({});
	const [exportDetailsLoading, setExportDetailsLoading] = useState(false);

	const params = { 
        headers: {
			'x-api-key': process.env.REACT_APP_API_KEY,        
			'Accept': 'application/json',
			'Content-Type': 'application/json',
        },
	}

	useEffect(()=>{
		const fetchDistrict = async () => {
			
			const districts = await API.get('settings','/DISTRICTS', params)

			const unique = [...new Set((districts.values || []).filter(Boolean))];
			const list = unique.map((name) => (
				<option key={name} value={name}>{name}</option>
			));

			setDistrictList(list);
		}
		fetchDistrict();	 
	}, []);
	
	// Load tasks
	useEffect(()=>{

		let giveFormatTasks = async (tasks_format) => {
			for (let i = 0; i < tasks_format.length; i++) {
				switch (tasks_format[i].task_status) {
					case 'Created': 
						tasks_format[i].cssTaskStatus = "task_created"; 
						break;
					case 'Accepted': 
						tasks_format[i].cssTaskStatus = "task_accepted"; 
						break;
					case 'Started': 
						tasks_format[i].cssTaskStatus = "task_started"; 
						break;
					case 'Completed': 
						tasks_format[i].cssTaskStatus = "task_completed"; 
						break;
					case 'WIP': 
						tasks_format[i].cssTaskStatus = "task_wip"; 
						break;
					default: 
						tasks_format[i].cssTaskStatus = "taskStatus";
				}
											
				if (tasks_format[i].date_created){
					tasks_format[i].date_created_str = (
						<div className="date-cell">
							<Moment local format='DD-MM-YYYY' date={ tasks_format[i].date_created } />
							<span className="date-cell-time">
								<Moment local format='HH:mm' date={ tasks_format[i].date_created } />
							</span>
						</div>
					);
				}

				if (tasks_format[i].date_completed){
					tasks_format[i].date_completed_str = (
						<div className="date-cell">
							<Moment local format='DD-MM-YYYY' date={ tasks_format[i].date_completed } />
							<span className="date-cell-time">
								<Moment local format='HH:mm' date={ tasks_format[i].date_completed } />
							</span>
						</div>
					);
				}
				if (tasks_format[i].invoice_date){
					tasks_format[i].invoice_date_str = <Moment local format='DD-MM-YYYY' date={ tasks_format[i].invoice_date } />
				}

				if (tasks_format[i].sla_attend){
					if (tasks_format[i].category==="Reactive"){
						tasks_format[i].sla_attend = tasks_format[i].sla_attend + ' hrs'
					}else{
						tasks_format[i].sla_attend = tasks_format[i].sla_attend + ' days'
					}
				}

			}

			//sort array desc
			tasks_format.sort((a, b) => (a.date_created > b.date_created) ? 1 : -1)
			tasks_format.reverse();
		}

		const fetchTasksList = async () => {
			setIsLoading(true);
			setTasksLoaded(false);

			API.get('users','/', params)
			.then(res => {
				let userList = []; 
				res.Users.forEach((item) => {
					let user ={}
					user.id = item.Username;
					item.Attributes.forEach((e) => {
						if (e.Name === 'name')
							user.name = e.Value;
					}) 
					userList.push(user);  
					setUsers(userList);     
				})
			})

			const tasks = await API.get('task_completed_list','/', params)
			giveFormatTasks(tasks)
			setTasks(tasks);
			setTaskList(tasks);
			setIsLoading(false);
			setTasksLoaded(true);
		}

		const fetchTasksReport = async () => {
			try {
				const tasks_completed = await API.get('task_completed','/', params)
				giveFormatTasks(tasks_completed)
				setTaskReport(Array.isArray(tasks_completed) ? tasks_completed : []);
			} catch (err) {
				// sdcc payload often exceeds Lambda 6MB → 502; Excel enrichment fills costs for filtered rows
				console.error('task_completed failed; Excel will enrich from task_active', err);
				setTaskReport([]);
			}
		}
		fetchTasksList();
		fetchTasksReport();
	}, []);

	useEffect(()=>{
		for (let i = 0; i < taskReport.length; i++) {			
			if (taskReport[i].user_completed){
				const usr_comp = users.find(usr => usr.id === taskReport[i].user_completed)				
				if (usr_comp) 
					taskReport[i].user_completed_str = usr_comp.name
			}			
		}		
		setIsLoading(false);
    },[users,taskReport])

	// When bulk report API is empty/failed, fetch full task details for the filtered table rows
	// so Excel can include costs/materials (e.g. task_active/:id).
	useEffect(() => {
		if (!tasksLoaded || taskList.length === 0) {
			return undefined;
		}

		const MAX_ENRICH = 400;
		if (taskList.length > MAX_ENRICH) {
			return undefined;
		}

		const reportIds = {};
		for (let i = 0; i < taskReportList.length; i++) {
			const t = taskReportList[i];
			if (t && t.taskId) reportIds[t.taskId] = t;
		}

		const missing = taskList.filter((t) => {
			if (!t || !t.taskId) return false;
			if (exportDetailsById[t.taskId]) return false;
			const reportRow = reportIds[t.taskId];
			// Report row already has cost/material fields — no need to fetch
			if (reportRow && (
				reportRow.total_cost != null ||
				reportRow.callout_subtotal != null ||
				reportRow.onsite_subtotal != null ||
				(Array.isArray(reportRow.materials_items) && reportRow.materials_items.length > 0)
			)) {
				return false;
			}
			// Missing from report entirely, or report row has no cost fields
			return !reportRow || (
				reportRow.total_cost == null &&
				reportRow.callout_subtotal == null &&
				reportRow.onsite_subtotal == null &&
				!(Array.isArray(reportRow.materials_items) && reportRow.materials_items.length > 0)
			);
		});

		if (missing.length === 0) {
			return undefined;
		}

		let cancelled = false;
		const enrich = async () => {
			setExportDetailsLoading(true);
			const BATCH = 8;
			const collected = {};
			try {
				for (let i = 0; i < missing.length; i += BATCH) {
					if (cancelled) return;
					const batch = missing.slice(i, i + BATCH);
					const results = await Promise.all(batch.map(async (item) => {
						try {
							const detail = await API.get('task_active', '/' + item.taskId, params);
							if (detail && detail.taskId && detail.ok !== false) {
								if (detail.user_completed && users.length) {
									const usr = users.find((u) => u.id === detail.user_completed);
									if (usr) detail.user_completed_str = usr.name;
								}
								return detail;
							}
						} catch (e) {
							console.error('Failed to enrich task for Excel', item.taskId, e);
						}
						return null;
					}));
					results.forEach((detail) => {
						if (detail) collected[detail.taskId] = detail;
					});
				}
				if (!cancelled && Object.keys(collected).length > 0) {
					setExportDetailsById((prev) => ({ ...prev, ...collected }));
				}
			} finally {
				if (!cancelled) setExportDetailsLoading(false);
			}
		};
		enrich();
		return () => { cancelled = true; };
	// intentionally omit exportDetailsById from deps to avoid re-fetch loops; missing check skips cached ids
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tasksLoaded, taskList, taskReportList, users]);

	// Restore filters from localStorage on mount
	useEffect(() => {
		const saved = localStorage.getItem(FILTERS_KEY);
		if (saved) {
			const filters = JSON.parse(saved);
			const restored = {
				dateFrom: filters.dateFrom ? new Date(filters.dateFrom) : '',
				dateTo: filters.dateTo ? new Date(filters.dateTo) : '',
				dateCompletedFrom: filters.dateCompletedFrom ? new Date(filters.dateCompletedFrom) : '',
				dateCompletedTo: filters.dateCompletedTo ? new Date(filters.dateCompletedTo) : '',
				siteRef: filters.siteRef || '',
				taskRef: filters.taskRef || '',
				district: filters.district || '',
				category: filters.category || '',
				subcategory: filters.subcategory || '',
				invoiceStatus: filters.invoiceStatus || '',
				taskStatus: filters.taskStatus || '',
			};
			setDateFrom(restored.dateFrom);
			setDateTo(restored.dateTo);
			setDateCompletedFrom(restored.dateCompletedFrom);
			setDateCompletedTo(restored.dateCompletedTo);
			setSiteRef(restored.siteRef);
			setTaskRef(restored.taskRef);
			setDistrict(restored.district);
			setCategory(restored.category);
			setSubcategory(restored.subcategory);
			setInvoiceStatus(restored.invoiceStatus);
			setTaskStatus(restored.taskStatus);
			const hasActiveFilters = Object.values(restored).some((value) => value !== '' && value !== null);
			if (hasActiveFilters) {
				setAppliedFilters(restored);
			}
		}
		setFiltersLoaded(true);
	}, []);

	// Save filters to localStorage whenever they change
	useEffect(() => {
		const filters = {
			dateFrom: dateFrom ? dateFrom.toISOString() : '',
			dateTo: dateTo ? dateTo.toISOString() : '',
			dateCompletedFrom: dateCompletedFrom ? dateCompletedFrom.toISOString() : '',
			dateCompletedTo: dateCompletedTo ? dateCompletedTo.toISOString() : '',
			siteRef,
			taskRef,
			district,
			category,
			subcategory,
			invoiceStatus,
			taskStatus,
		};
		localStorage.setItem(FILTERS_KEY, JSON.stringify(filters));
	}, [dateFrom, dateTo, dateCompletedFrom, dateCompletedTo, siteRef, taskRef, district, category, subcategory, invoiceStatus, taskStatus]);

	useEffect(() => {
		if (filtersLoaded && tasksLoaded) {
			handleSearch([...tasks], setTaskList, appliedFilters);
			handleSearch([...taskReport], setTaskReportList, appliedFilters);
		}
	}, [filtersLoaded, tasksLoaded, tasks, taskReport, appliedFilters]);

	const handleApplyFilters = () => {
		setAppliedFilters({
			dateFrom,
			dateTo,
			dateCompletedFrom,
			dateCompletedTo,
			siteRef,
			taskRef,
			district,
			category,
			subcategory,
			invoiceStatus,
			taskStatus,
		});
	};

	const handleClearSearch = () => {
		setDateFrom('');
		setDateTo('');
		setDateCompletedFrom('');
		setDateCompletedTo('');
		setSiteRef('');
		setTaskRef('');
		setDistrict('');
		setCategory('');
		setSubcategory('');
		setInvoiceStatus('');
		setTaskStatus('');
		setAppliedFilters({
			dateFrom: '',
			dateTo: '',
			dateCompletedFrom: '',
			dateCompletedTo: '',
			siteRef: '',
			taskRef: '',
			district: '',
			category: '',
			subcategory: '',
			invoiceStatus: '',
			taskStatus: '',
		});
		localStorage.removeItem(FILTERS_KEY);
	}

	const handleSearch = (results, setResultsList, filters) => {
		const hasInvoiceData = (item) => {
			const invoiceDate = (item && item.invoice_date ? item.invoice_date.toString() : '').trim().toLowerCase();
			const invoiceNumber = (item && item.invoice_number ? item.invoice_number.toString() : '').trim().toLowerCase();
			const hasInvoiceDate = invoiceDate !== '' && invoiceDate !== 'null' && invoiceDate !== 'undefined';
			const hasInvoiceNumber = invoiceNumber !== '' && invoiceNumber !== 'null' && invoiceNumber !== 'undefined';
			return hasInvoiceDate || hasInvoiceNumber;
		};

		// Date Created From (clone so we never mutate the DatePicker / appliedFilters value)
		if (filters.dateFrom){
			const date_from = new Date(filters.dateFrom);
			date_from.setHours(0, 0, 0, 0);
			const date_from_iso = date_from.toISOString();
			results = results.filter(item =>
				item.date_created && item.date_created >= date_from_iso
		)}
		
		// Date Created To
		if (filters.dateTo){
			const date_to = new Date(filters.dateTo);
			date_to.setHours(23, 59, 59, 999);
			const date_to_iso = date_to.toISOString();

			results = results.filter(item =>
				item.date_created && item.date_created <= date_to_iso
		)}

		// Date Completed From (WIP tasks may not have date_completed)
		if (filters.dateCompletedFrom){
			const completed_from = new Date(filters.dateCompletedFrom);
			completed_from.setHours(0, 0, 0, 0);
			const completed_from_iso = completed_from.toISOString();
			results = results.filter(item =>
				item.task_status === 'WIP' ||
				(item.date_completed && item.date_completed >= completed_from_iso)
		)}

		// Date Completed To (WIP tasks may not have date_completed)
		if (filters.dateCompletedTo){
			const completed_to = new Date(filters.dateCompletedTo);
			completed_to.setHours(23, 59, 59, 999);
			const completed_to_iso = completed_to.toISOString();

			results = results.filter(item =>
				item.task_status === 'WIP' ||
				(item.date_completed && item.date_completed <= completed_to_iso)
		)}

		// Task Status
		if (filters.taskStatus){
			results = results.filter(item => item.task_status === filters.taskStatus);
		}
		
		// Asset
		if (filters.siteRef){
			results = results.filter(results =>
				results.site_ref.toLowerCase().includes(filters.siteRef.toLowerCase())
		)}

		// Task Ref
		if (filters.taskRef){
			results = results.filter(results =>
				results.task_ref && results.task_ref.toString().includes(filters.taskRef.toString())
		)}

		// District
		if (filters.district){
			results = results.filter(results =>
				results.district && results.district.includes(filters.district)
		)}

		// Category
		if (filters.category){
			results = results.filter(results =>
				results.category && results.category.includes(filters.category)
		)}

		// SubCategory
		if (filters.subcategory){
			results = results.filter(results =>
				results.type_fault && results.type_fault.includes(filters.subcategory)
		)}
		
		// Invoice status
		if (filters.invoiceStatus === 'Invoiced'){
			results = results.filter(item => hasInvoiceData(item))
		}
		if (filters.invoiceStatus === 'Not Invoiced'){
			results = results.filter(item => !hasInvoiceData(item))
		}

		//TODO search more items in the database

		setResultsList(results);
		paginate(1);
		
	}
		
	const handleCategory = () => {
		setSubcategory('');
		const cat = localdb.CATEGORY;
		let subcat = "";
		for (let i = 0; i < cat.length; i++) {
			if (cat[i].key === category) {
				subcat = cat[i].subcategory.map((item, j) => (
					<option key={"subcategory"+j} value={item} >{tCatalog(item)}</option>)
				)
			}
		}
		setSubcategoryList(subcat);
	}
	
	useEffect(() => {
		handleCategory();
	}, [category, language]); 


	useEffect(() => {
		localStorage.setItem(PAGE_SIZE_KEY, String(pageSize));
		setCurrentPage(1);
	}, [pageSize]);

	const indexOfLastItem = currentPage * pageSize;
	const indexOfFirstItem = indexOfLastItem - pageSize;
	const currentItemList = taskList.slice(indexOfFirstItem, indexOfLastItem);
	const rangeStart = taskList.length === 0 ? 0 : indexOfFirstItem + 1;
	const rangeEnd = Math.min(indexOfLastItem, taskList.length);

	const paginate = (pageNumber) => {
		setCurrentPage(pageNumber);
		setExpandedId(null);
	};

	const toggleExpand = (taskId) => {
		setExpandedId((current) => (current === taskId ? null : taskId));
	};


	const categoryList = localdb.CATEGORY.map((item, i) => (
		<option key={"category"+i} value={item.key}>{tCatalog(item.description)}</option>
	));

	// Excel must match the filtered table rows. Prefer full report records (costs/materials),
	// then per-task enrichment from task_active (when bulk /task_completed 502s), else list row.
	const reportByTaskId = {};
	for (let i = 0; i < taskReportList.length; i++) {
		const reportTask = taskReportList[i];
		if (reportTask && reportTask.taskId) {
			reportByTaskId[reportTask.taskId] = reportTask;
		}
	}
	const rowHasCosts = (row) => !!(row && (
		row.total_cost != null ||
		row.callout_subtotal != null ||
		row.onsite_subtotal != null ||
		(Array.isArray(row.materials_items) && row.materials_items.length > 0)
	));
	const excelDataSet = taskList.map((listTask) => {
		if (!listTask || !listTask.taskId) return listTask;
		const report = reportByTaskId[listTask.taskId];
		const detail = exportDetailsById[listTask.taskId];
		if (rowHasCosts(report)) return report;
		// task_active has costs but not asset site fields — keep list site data underneath
		if (rowHasCosts(detail)) return { ...listTask, ...detail };
		if (report) return report;
		if (detail) return { ...listTask, ...detail };
		return listTask;
	});

	const renderRow = (item) => {
		const open = expandedId === item.taskId;
		const description = item.fault_description || item.site_address || 'No description';
		const placeName = [item.site_address, item.district].filter(Boolean).join(' · ');
		const categoryLine = [tCatalog(item.category), tCatalog(item.type_fault)].filter(Boolean).join(' · ');
		const completedLabel = formatWhen(item.date_completed);
		const createdLabel = formatWhen(item.date_created);
		const invoiceLabel = formatWhen(item.invoice_date || item.invoiceDate);

		return (
			<article
				key={item.taskId}
				className={`task-ops-item${open ? ' is-open' : ''}`}
				onClick={() => toggleExpand(item.taskId)}
			>
				<div className="task-ops-row" role="button" tabIndex={0} aria-expanded={open}
					onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleExpand(item.taskId); } }}>
					<div className="task-ops-identity">
						<Link className="task-ops-id" to={`/task_det/${item.taskId}`} onClick={(e) => e.stopPropagation()}>
							#{item.task_ref}
						</Link>
						{item.task_status && <span className={`task-ops-status ${item.cssTaskStatus}`}>{item.task_status}</span>}
						{isUrgentItem(item) && (
							<span className="task-ops-flag" title="Urgent">
								<span className="task-ops-flag-dot" aria-hidden="true" />
								Urgent
							</span>
						)}
						{completedLabel && <span className="task-ops-date">{completedLabel}</span>}
					</div>
					<button type="button" className="task-ops-toggle" aria-label={open ? 'Collapse task' : 'Expand task'}
						onClick={(e) => { e.stopPropagation(); toggleExpand(item.taskId); }}>
						{open ? <FaChevronDown /> : <FaChevronRight />}
					</button>
					<p className="task-ops-title" title={description}>{description}</p>
					<div className="task-ops-meta">
						<div className="task-ops-place">
							{item.site_ref && <span className="task-ops-site-code">{item.site_ref}</span>}
							{placeName && <span className="task-ops-site-name" title={placeName}>{placeName}</span>}
							{categoryLine && <span className="task-ops-cat">· {categoryLine}</span>}
						</div>
						{(invoiceLabel || item.sla_attend) && (
							<div className="task-ops-sla-wrap">
								{invoiceLabel && <span className="task-ops-sla">{t('taskView.invoice')} {invoiceLabel}</span>}
								{item.sla_attend && <span className="task-ops-sla-repair">{invoiceLabel ? ' · ' : ''}SLA {item.sla_attend}</span>}
							</div>
						)}
					</div>
				</div>
				{open && (
					<div className="task-ops-detail">
						<div className="task-ops-detail-inner">
							<dl>
								<div className="is-wide">
									<dt>{t('common.address')}</dt>
									<dd>{item.site_address || '—'}{item.district ? ` · ${item.district}` : ''}</dd>
								</div>
								<div>
									<dt>{t('common.created')}</dt>
									<dd>{createdLabel || '—'}</dd>
								</div>
								<div>
									<dt>{t('common.completed')}</dt>
									<dd>{completedLabel || '—'}</dd>
								</div>
								<div>
									<dt>{t('fields.invoiceDate')}</dt>
									<dd>{invoiceLabel || '—'}</dd>
								</div>
								<div>
									<dt>{t('common.classification')}</dt>
									<dd>{item.urgent_fault || '—'}</dd>
								</div>
								<div>
									<dt>{t('tasks.slaAttend')}</dt>
									<dd>{item.sla_attend || '—'}</dd>
								</div>
							</dl>
							<div className="task-ops-actions">
								<Link className="task-ops-open" to={`/task_det/${item.taskId}`} onClick={(e) => e.stopPropagation()}>
									<FaExternalLinkAlt /> {t('tasks.openTask')}
								</Link>
							</div>
						</div>
					</div>
				)}
			</article>
		);
	};

	return (
	<div className="MonthlyReport">
		<div>
			<PageHeader
				title={t('pages.monthlyReport.title')}
				subtitle={t('pages.monthlyReport.subtitle')}
				breadcrumbs={[
					{ label: t('nav.reports') },
					{ label: t('pages.monthlyReport.title') },
				]}
				count={!isLoading ? taskList.length : undefined}
				countLabel={t('common.tasks')}
				countSingular={t('common.task')}
				actions={
					<div className="d-flex align-items-center">
						{exportDetailsLoading ? (
							<span className="text-muted small mr-2">{t('report.loadingCosts')}</span>
						) : null}
						<MonthlyReportXls dataSet={excelDataSet} name={t('exportDoc.monthlyReport')} dateFrom={appliedFilters.dateFrom} dateTo={appliedFilters.dateTo} />
					</div>
				}
			/>
			<div className="task-ops">
				<Form className="compact-filters task-ops-filters" onSubmit={(e) => { e.preventDefault(); handleApplyFilters(); }}>
					<div className="task-ops-filters-main">
						<Form.Control size="sm" placeholder={t('tasks.taskRef')} value={taskRef} onChange={(e) => setTaskRef(e.target.value)} />
						<Form.Control size="sm" placeholder={t('tasks.siteRef')} value={siteRef} onChange={(e) => setSiteRef(e.target.value)} />
						<Form.Control as="select" size="sm" value={district} onChange={(e) => setDistrict(e.target.value)}>
							<option value="">{t('common.district')}</option>
							{districtList}
						</Form.Control>
						<Form.Control as="select" size="sm" value={category} onChange={(e) => setCategory(e.target.value)}>
							<option value="">{t('common.category')}</option>
							{categoryList}
						</Form.Control>
						<Form.Control as="select" size="sm" value={taskStatus} onChange={(e) => setTaskStatus(e.target.value)}>
							<option value="">{t('report.completedWip')}</option>
							<option value="Completed">{t('status.completed')}</option>
							<option value="WIP">{t('status.wip')}</option>
						</Form.Control>
						<button type="button" className={`task-ops-more${showMoreFilters ? ' is-open' : ''}`} aria-expanded={showMoreFilters} onClick={() => setShowMoreFilters((v) => !v)}>{t('common.moreFilters')}</button>
						<button type="submit" className="task-ops-apply">{t('common.search')}</button>
						<button type="button" className="task-ops-reset" onClick={handleClearSearch}>{t('common.reset')}</button>
					</div>
					{showMoreFilters && (
						<div className="task-ops-filters-panel">
							<Form.Control as="select" size="sm" value={subcategory} onChange={(e) => setSubcategory(e.target.value)} disabled={!category}>
								<option value="">{t('common.subcategory')}</option>
								{subcategoryList}
							</Form.Control>
							<Form.Control as="select" size="sm" value={invoiceStatus} onChange={(e) => setInvoiceStatus(e.target.value)}>
								<option value="">{t('report.exportFilter')}</option>
								<option value="Invoiced">{t('report.invoiced')}</option>
								<option value="Not Invoiced">{t('report.notInvoiced')}</option>
							</Form.Control>
							<DatePicker selected={dateFrom || null} onChange={setDateFrom} className="form-control form-control-sm" placeholderText={t('tasks.createdFrom')} dateFormat="dd/MM/yyyy" isClearable popperContainer={DatePickerPopperContainer} />
							<DatePicker selected={dateTo || null} onChange={setDateTo} className="form-control form-control-sm" placeholderText={t('tasks.createdTo')} dateFormat="dd/MM/yyyy" isClearable popperContainer={DatePickerPopperContainer} />
							<DatePicker selected={dateCompletedFrom || null} onChange={setDateCompletedFrom} className="form-control form-control-sm" placeholderText={t('tasks.completedFrom')} dateFormat="dd/MM/yyyy" isClearable popperContainer={DatePickerPopperContainer} />
							<DatePicker selected={dateCompletedTo || null} onChange={setDateCompletedTo} className="form-control form-control-sm" placeholderText={t('tasks.completedTo')} dateFormat="dd/MM/yyyy" isClearable popperContainer={DatePickerPopperContainer} />
						</div>
					)}
				</Form>

				<div className="task-ops-panel" aria-busy={isLoading}>
					{isLoading ? (
						<div className="loading-container">
							<div className="loading-content">
								<Spinner animation="border" role="status" variant="primary" className="loading-spinner" />
								<div className="loading-text">{t('report.loading')}</div>
							</div>
						</div>
					) : (
						<>
							<div className="task-ops-legend" aria-hidden="true">{t('tasks.legendCompleted')}</div>
							<div className="task-ops-list">
								{currentItemList.length === 0 ? (
									<div className="task-ops-empty">{t('report.empty')}</div>
								) : currentItemList.map(renderRow)}
							</div>
							<div className="task-ops-footer">
								<p className="task-ops-range">{t('tasks.showing', { start: rangeStart, end: rangeEnd, total: taskList.length })}</p>
								<div className="task-ops-pagesize">
									<label htmlFor="report-pagesize">{t('common.rows')}</label>
									<select id="report-pagesize" value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
										{PAGE_SIZES.map((size) => <option key={size} value={size}>{size}</option>)}
									</select>
								</div>
								<Pagination sizePerPage={pageSize} currentPage={currentPage} totalSize={taskList.length} changeCurrentPage={paginate} theme="bootstrap" />
							</div>
						</>
					)}
				</div>
			</div>
		</div>
	</div>
	);
}


export default MonthlyReport;
